<template>
    <div>
        <radial-progress-bar
            :diameter="175"
            :strokeWidth="6"
            :innerStrokeWidth="6"
            :completed-steps="currentValue"
            :total-steps="computedMaxValue"
            :innerStrokeColor="colorList.background"
            :stopColor="stopColor"
            :startColor="startColor"
        >
            <p>{{ trans.total_connected }}</p>
            <p>
                <span :class="isUserLimitExceeded ? ['has-text-danger', 'has-text-weight-bold'] : ''">
                    {{ currentValue }}
                </span>
                {{ trans.of }}
                <span
                    :class="[
                        isUserLimitExceeded ? ['has-text-info', 'has-text-weight-bold'] : '',
                        { 'vertical-align-bottom': isUserLimitInfinite }
                    ]"
                >
                    <i class="fas fa-infinity" v-if="isUserLimitInfinite"></i>
                    <span v-else>{{ userLimit }}</span>
                </span>
            </p>
        </radial-progress-bar>
    </div>
</template>

<script>
    import RadialProgressBar from 'vue-radial-progress';
    import {mapActions, mapGetters, mapState} from "vuex";

    export default {
        name: "UserLimitIndicator",
        components: {
            RadialProgressBar,
        },
        props: {
            maxUsers: {
                type: [Number, String],
            },
            trans: Object,
        },
        data () {
            return {
                startColor: null,
                stopColor: null,
                colorList: {
                    stop: {
                        less: "#2285ff",
                    },
                    start: {
                        less: "#22ccff",
                        equal: "#2285ff",
                        more: "#f54819",
                        infinite: "#23d160"
                    },
                    background: "#aaa9a9",
                }
            };
        },
        mounted() {
            this.setUserLimit(this.maxUsers);
        },
        computed: {
            ...mapState("userManagement", ["userLimit"]),
            ...mapGetters("userManagement", {
                currentValue: "totalUsers",
                isUserLimitExceeded: "isUserLimitExceeded",
                isUserLimitInfinite: "isUserLimitInfinite",
            }),
            computedMaxValue() {
                return (this.isUserLimitExceeded || this.isUserLimitInfinite)
                    ? this.currentValue
                    : this.userLimit;
            },
        },
        watch: {
            /**
             * Изменение цвета индикатора при действиях с пользователями
             */
            currentValue() {
                let key;
                if (this.isUserLimitInfinite) {
                    key = 'infinite';
                } else if (this.currentValue == this.userLimit) {
                    key = 'equal';
                } else if (this.currentValue > this.userLimit) {
                    key = 'more';
                } else {
                    key = 'less';
                }

                this.startColor = this.colorList.start[key];
                this.stopColor = this.colorList.stop[key] ?? this.colorList.start[key];
            }
        },
        methods: {
            ...mapActions("userManagement", ["setUserLimit"]),
        },
    }
</script>

<style lang="scss" scoped>
    .vertical-align-bottom {
        vertical-align: text-bottom;
    }
</style>
